<!-- Пустое состояние левой панели, когда ПЛАН заказа ещё не рассчитан. -->
<template>
  <section class="plan-empty-panel">
    <strong>ПЛАН ещё не рассчитан</strong>
    <span>Выберите калькулятор и создайте первую версию расчёта.</span>
    <PlanCalculationActionButton
      v-if="canCalculate"
      size="regular"
      :disabled="isCalculating"
      @click="$emit('calculate')"
    >
      {{ isCalculating ? "Рассчитываем…" : "Рассчитать ПЛАН" }}
    </PlanCalculationActionButton>
  </section>
</template>

<script>
import PlanCalculationActionButton from "@/components/Order/PlanCalculation/Buttons/Action.vue";

export default {
  name: "OrderPlanCalculationEmptyPanel",

  components: { PlanCalculationActionButton },

  props: {
    canCalculate: { type: Boolean, default: false },
    isCalculating: { type: Boolean, default: false },
  },

  emits: ["calculate"],
};
</script>

<style scoped>
.plan-empty-panel {
  display: flex;
  min-height: 180px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  box-sizing: border-box;
  border: 1px solid #dce3f3;
  border-radius: 10px;
  color: #5b6070;
  font-size: 13px;
  text-align: center;
}

.plan-empty-panel strong {
  color: #252a3a;
  font-size: 15px;
}
</style>
